<template>
    <div class="sign-detail">
        <el-dialog :visible="dialogVisible" width="700px" @close="closeDialog" :close-on-click-modal="false">
            <div slot="title" class="dialogTitle">{{ dialogTitle }}</div>
            <!--申请流程示意图-->
            <!--流程信息-->
            <div class="processInfo">
                <!--步骤条  前端先定义：0-发起申请，1-申请取消，2-审核中，3-审核通过，4-审核驳回-->
                <div class="steps-conatiner" v-if="rowItem.applyStatus !== 1">
                    <el-steps direction="vertical" :active="activeStep" finish-status="success"
                        :key="rowItem.applyStatus">
                        <template>
                            <el-step></el-step>
                            <el-step :icon="rowItem.applyStatus === 2 ? 'el-icon-pie-chart' : ''"></el-step>
                        </template>
                    </el-steps>
                </div>
                <div class="steps-content-container">
                    <div class="steps-content">
                        <div>
                            <el-avatar icon="el-icon-s-custom" style="background-color: #20c997" :size="60"></el-avatar>
                        </div>
                        <div style="font-size: 16px;text-align: left;margin-left: 20px;">
                            <div :title="rowItem.applicationName" style="margin-bottom: 12px;margin-top: 2px;">
                                {{ rowItem.applicationName }}</div>
                            <div style="color: #409EFF;" v-if="rowItem.applyStatus !== 1">发起申请</div>
                            <div style="color: #F56C6C;" v-else>已取消</div>
                        </div>
                        <div class="step-time">{{ rowItem.applicationTime }}</div>
                    </div>
                    <div v-if="rowItem.applyStatus === 2">
                        <div class="steps-content-approver">
                            <div style="display: flex;">
                                <div>
                                    <el-avatar icon="el-icon-user-solid" style="background-color: #409EFF"
                                        :size="60"></el-avatar>
                                </div>
                                <div style="font-size: 16px;text-align: left;margin-left: 20px;width: 250px;">
                                    <div :title="rowItem.authorizedApproversList?.map(item => item.realName).join(', ')"
                                        style="margin-bottom: 12px;margin-top: 2px;">
                                        {{rowItem.authorizedApproversList?.map(item => item.realName).join(', ')}}
                                    </div>
                                    <div :style="{ color: '#E6A23C' }">
                                        待审核
                                    </div>
                                </div>
                                <div class="step-time" :title="'已等待' + detailTimer.hours + '小时' + detailTimer.minutes + '分钟'"
                                    style="color: orange;max-width: 150px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                                    已等待{{ detailTimer.hours }}小时{{
                                        detailTimer.minutes }}分钟
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="rowItem.applyStatus === 3">
                        <div class="steps-content-approver">
                            <div style="display: flex;">
                                <div>
                                    <el-avatar icon="el-icon-user-solid" style="background-color: #409EFF"
                                        :size="60"></el-avatar>
                                </div>
                                <div style="font-size: 16px;text-align: left;margin-left: 20px;">
                                    <div :title="rowItem.approver" style="margin-bottom: 12px;margin-top: 2px;">
                                        {{ rowItem.approver }}
                                    </div>
                                    <div :style="{ color: '#409EFF' }">
                                        审核通过
                                    </div>
                                </div>
                                <div class="step-time">{{ rowItem.approvedTime }}</div>
                            </div>
                            <div v-if="rowItem.approvedComment"
                                style="font-size: 16px;text-align: left;padding-left: 80px;">
                                审批意见：{{ rowItem.approvedComment }}
                            </div>
                        </div>
                    </div>
                    <div v-if="rowItem.applyStatus === 4">
                        <div class="steps-content-approver">
                            <div style="display: flex;">
                                <div>
                                    <el-avatar icon="el-icon-user-solid" style="background-color: #409EFF"
                                        :size="60"></el-avatar>
                                </div>
                                <div style="font-size: 16px;text-align: left;margin-left: 20px;">
                                    <div :title="rowItem.approver" style="margin-bottom: 12px;margin-top: 2px;">
                                        {{ rowItem.approver }}
                                    </div>
                                    <div :style="{ color: '#F56C6C' }">
                                        审核驳回
                                    </div>
                                </div>
                                <div class="step-time">{{ rowItem.approvedTime }}</div>
                            </div>
                            <div v-if="rowItem.approvedComment"
                                style="font-size: 16px;text-align: left;padding-left: 80px;">
                                审批意见：{{ rowItem.approvedComment }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--信息栏目-->
            <el-form :model="operate" ref="operate" label-width="0px" label-position="left" class="soft-update-form">
                <div>
                    <div class="attrItem">
                        <div class="attrTitle">产品类型</div>
                        <div class="attrValue">{{ rowItem.productTypeName }}</div>
                    </div>
                    <div class="attrItem">
                        <div class="attrTitle">产品套餐/型号</div>
                        <div class="attrValue">{{ rowItem.productPackageName }}</div>
                    </div>
                    <div class="attrItem">
                        <div class="attrTitle">销售类型</div>
                        <div class="attrValue">{{ rowItem.market == 1 ? '内销' : '出口' }}</div>
                    </div>
                    <div class="attrItem">
                        <div class="attrTitle">订单编号</div>
                        <div class="attrValue">{{ rowItem.orderNumber }}</div>
                    </div>
                    <div class="attrItem">
                        <div class="attrTitle">工程名称</div>
                        <div class="attrValue">{{ rowItem.engineeringName }}</div>
                    </div>
                    <div class="attrItem">
                        <div class="attrTitle">工程地点</div>
                        <div class="attrValue">
                            <template>
                                {{
                                    (rowItem.province ? rowItem.province : '')
                                    + (rowItem.city ? rowItem.city : '')
                                    + (rowItem.engineeringAddress ? rowItem.engineeringAddress : '')
                                }}
                            </template>
                        </div>
                    </div>
                    <div class="attrItem">
                        <div class="attrTitle">软件序列号</div>
                        <div class="attrValue">{{ rowItem.productSerialNumber }}</div>
                    </div>
                    <div class="attrItem" style="display: flex; align-items: center;" v-if="isForm">
                        <div class="attrTitle">审批<span class="badge">*</span></div>
                        <el-form-item prop="signResult"
                            :rules="[{ message: '不能为空', trigger: ['blur'], required: true }]">
                            <el-radio-group v-model="operate.signResult">
                                <el-radio :label="1">通过</el-radio>
                                <el-radio :label="2">驳回</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="attrItem" style="display: flex; align-items: center;" v-if="isForm">
                        <div class="attrTitle">办理意见<span class="badge">*</span></div>
                        <el-form-item prop="reason" :rules="[{ message: '不能为空', trigger: ['blur'], required: true }]">
                            <el-input v-model="operate.reason" type="textarea" maxlength="200"></el-input>
                        </el-form-item>
                    </div>
                    <div style="text-align: right;" v-if="isForm">
                        <div class="customBtn btnMr" @click="closeDialog">取消</div>
                        <div class="customBtn" @click="confirm">确定</div>
                    </div>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { updateApprovalStatus } from "@/api/softUpdate";
export default {
    props: {
        isForm: {
            type: Boolean,
            default: false,
        },
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        rowItem: {
            type: Object,
            default: () => { },
        },
        dialogTitle: {
            type: String,
            default: "申请详情",
        }
    },
    computed: {
        ...mapGetters(['getUserName']),
        activeStep() {
            // 步骤条更新步数
            if (this.rowItem.applyStatus === 2) {
                return 1;
            } else {
                return 2;
            }
        }
    },
    data() {
        return {
            detailTimer: {
                hours: 0,
                minutes: 0,
            },
            sponsor: sessionStorage.getItem('realName'),
            operate: {
                signResult: '',
                reason: '',
            },
        }
    },
    watch: {
        async dialogVisible(newVal) {
            if (newVal) {
                await this.$nextTick();
                this.calWaitTime(this.rowItem.applicationTime);
            } else {
                this.closeInterval();
            }
        }
    },
    methods: {
        // 计算等待时间
        calWaitTime(applyTime) {
            let stime = new Date(applyTime).getTime();
            let etime = new Date().getTime();
            let usetime = etime - stime;

            let h = Math.floor(usetime / (3600 * 1000));
            let leave = usetime % (3600 * 1000);
            let min = Math.floor(leave / (60 * 1000));

            this.detailTimer.hours = h;
            this.detailTimer.minutes = min;
            this.startInterval();
        },
        closeInterval() {
            if (this.intervalTimer) {
                clearInterval(this.intervalTimer);
                this.intervalTimer = null;
            }
        },

        startInterval() {
            this.closeInterval();
            this.intervalTimer = setInterval(() => {
                this.detailTimer.minutes++;
                if (this.detailTimer.minutes >= 60) {
                    this.detailTimer.hours++;
                    this.detailTimer.minutes = 0;
                }
            }, 60000)
        },
        confirm() {
            this.$refs.operate.validate((valid) => {
                if (valid) {
                    updateApprovalStatus({
                        userName: this.getUserName,
                        productId: this.rowItem.productId,
                        upgradeId: this.rowItem.productUpgradeId,
                        approvedStatus: Number(this.operate.signResult),
                        approvedComment: this.operate.reason
                    }).then((res) => {
                        this.$emit("getData");
                        this.closeDialog();
                    })
                }
            })
        },
        closeDialog() {
            this.$refs.operate.resetFields();
            this.$emit("closeDialog");
        },
    },
}
</script>

<style></style>
<!--流程图样式-->
<style lang="less" scoped>
.customBtn {
    background-color: #3399FF;
    color: #FFFFFF;
    font-size: 16px;
    height: 40px;
    width: 120px;
    line-height: 40px;
    display: inline-block;
    text-align: center;
    border-radius: 5px;
    cursor: pointer;
}

.btnMr {
    margin-right: 10px;
}

.badge {
    color: red;
    margin-left: 2px;
}

/* 流程信息 */
.steps-conatiner {
    display: inline-block;
    width: 40px;
    vertical-align: top;
    height: 152px;
}

.steps-content-container {
    display: inline-block;
    /*height: 260px;*/
    width: 500px;
    vertical-align: top;
    margin-top: -28px;
}

.steps-content {
    height: 60px;
    margin-bottom: 42px;
    border: 1px solid #bebebe;
    padding: 10px;
    position: relative;
    display: flex;
}

.steps-content-approver {
    min-height: 60px;
    margin-bottom: 42px;
    border: 1px solid #bebebe;
    padding: 10px;
    position: relative;
}

.step-time {
    position: absolute;
    top: 12px;
    right: 12px;
    font-weight: bold;
    font-size: 16px;
}

/deep/ .relativeError .el-form-item__error {
    position: relative;
    text-align: left;
}

/deep/ .moreWidth>.el-form-item__content {
    margin-left: 4.5rem !important;
}

/*查看详情样式*/
.attrItem {
    margin-bottom: 22px;
    text-align: left;

    /*标题样式*/
    .attrTitle {
        display: inline-block;
        width: 160px;
        padding-right: 12px;
        text-align: right;
        box-sizing: border-box;
        font-size: 18px;
        color: #224E7F;
        vertical-align: top;
    }

    /*数值样式*/
    .attrValue {
        display: inline-block;
        font-size: 16px;
        color: #333333;
        box-sizing: border-box;
        width: 350px;
        line-height: 27px;
        padding-left: 30px;
        word-break: break-word;
    }
}

/*详情弹窗标题样式*/
.dialogTitle {
    font-size: 18px;
    color: #224E7F;
    text-align: left;
    font-weight: bold;
    border-bottom: 1px solid #EEEEEE;
}

.soft-update-form {
    /deep/ .el-form-item {
        margin-bottom: 0;
        padding-left: 30px;
        width: 410px;
    }

    /deep/ .el-radio__inner {
        border: 1px solid #bebebe;
    }

    /deep/ .el-radio__inner:hover,
    /deep/ .el-radio__input.is-checked .el-radio__inner {
        border-color: #409EFF;
    }
}
</style>